module.exports = __webpack_public_path__ + "img/japan-flag.ff93b354.svg";